import {useMemo} from 'preact/hooks';
import cn from 'classnames';

import styles from '~/style/aigallery/enterpriseLevelCloudNativeHighAvailability.module.less';
import {
    enterpriseLevelCloudNativeHighAvailability as data,
    moduleTitleCn,
    moduleContentCn
} from '~/locals/aigallery/index';
import {useQfScreen} from '../comp/utils/hook';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

const id = 'highAvailability';

const EnterpriseLevelCloudNativeHighAvailability = () => {
    const {screenWidth: width} = useQfScreen();

    useCptDuration(id, {
        name: `${applicationName}-企业级云原生高可用-停留时长`
    });

    const _data_ = useMemo(() => {
        const _data = data.cards.flat(Infinity);
        const res = [[], []];
        for (let i = 0; i < _data.length; i++) {
            res[i % 2].push(_data[i]);
        }
        return res;
    });
    return (
        <div className={styles.container} id={id}>
            <div className={cn(styles.title, `${moduleTitleCn}`)}>{data.title}</div>
            <div className={`${moduleContentCn}`}>
                <div className={styles.subtitleIcon}>
                    <img
                        src={
                            require('../../../assets/qf/enterpriseLevelCloudNativeHighAvailability/circle.png').default
                        }
                        alt=""
                    />
                    <span>{data.subTitle}</span>
                </div>
            </div>
            <div className={`${moduleContentCn}`}>
                {width && width > 600
                    ? data.cards.map((ele, i) => (
                          <div className={`${styles.card} ${i === 1 ? styles['card-middle'] : ''}`}>
                              {ele.map(item => (
                                  <div className={styles['card-item']}>
                                      <div className={styles['card-item-icon']}>
                                          <img src={item.icon} alt="" className={styles['card-item-icon-img']} />
                                      </div>
                                      <div className={styles['card-item-right']}>
                                          <div className={styles['card-item-title']}>
                                              <div>{item.title}</div>
                                              <span className={styles['card-item-subTitle']}>{item.subTitle}</span>
                                          </div>
                                          <div className={styles['card-item-desc']}>{item.desc}</div>
                                      </div>
                                  </div>
                              ))}
                          </div>
                      ))
                    : _data_.map((ele, i) => (
                          <div className={styles.card}>
                              {ele.map(item => (
                                  <div className={styles['card-item']}>
                                      <div className={styles['card-item-icon']}>
                                          <img src={item.icon} alt="" className={styles['card-item-icon-img']} />
                                      </div>
                                      <div className={styles['card-item-right']}>
                                          <div className={styles['card-item-title']}>
                                              <div>{item.title}</div>
                                              <span className={styles['card-item-subTitle']}>{item.subTitle}</span>
                                          </div>
                                          <div className={styles['card-item-desc']}>{item.desc}</div>
                                      </div>
                                  </div>
                              ))}
                          </div>
                      ))}
            </div>
        </div>
    );
};

export default EnterpriseLevelCloudNativeHighAvailability;
